var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import isEmpty from 'lodash/isEmpty';
import { EventBoundary, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { ListingEnquiryFormGraphQL, MobileEnquiryCTAGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import { AllhomesKeyDetailsGraphQL } from '@domain-group/fe-co-allhomes-key-details';
import AllhomesListingPhotoCarousel from '@domain-group/fe-co-allhomes-listing-photo-carousel';
import { AllhomesListingMapGraphQL } from '@domain-group/fe-co-allhomes-listing-map';
import { AllhomesListingSuburbStatsGraphQL } from '@domain-group/fe-co-allhomes-listing-suburb-stats';
import { AllhomesListingSummaryGraphQL } from '@domain-group/fe-co-allhomes-listing-summary';
import StickyMobile from '@domain-group/fe-co-allhomes-sticky-footer';
import { ListingViewsGraphQL } from '../components/listing-views';
import StickySidebox from '../components/sticky-sidebox';
import OnMarketSidebox from '../components/on-market-sidebox';
import ParentDevelopmentCoverPhotoGraphQL from '../components/parent-development-cover-photo/parent-development-cover-photo-graphql';
import NewDevelopmentParentDetailsGraphQL from '../components/new-development-parent-details/new-development-parent-details-graphql';
import Description from '../components/description/description';
import DevelopmentHeader from '../components/development-header/development-header';
import { InspectionsAuctionsGraphQL } from '../components/inspections-auctions';
import { Inner, InnerLeft, InnerRight, Section, Clear, Bottom } from '../components/structure';
import NextEventGraphQL from '../components/next-event/next-event-graphql';
import { FeaturedArticle } from '../components/editorial';
import AllhomesListingWhatsNearbyGraphQL from '../components/what-is-nearby/allhomes-listing-whats-nearby-graphql';
import { ProjectEntityInfo } from '../components/project-entity-info/project-entity-info';
import { NbnCardGraphQL } from '../components/nbn-card';
import { scrollToEnquiryForm } from '../utils/scrolling';
import useBackToSearch from '../utils/back-to-search';
import { onMarketPropertyWrapper } from '../wrappers';
import ListingDetailsCommonProps, { ListingDetailsDefaultValues } from '../props/common-props';
import useSendPageView from '../analytics/use-send-page-view';
import * as styles from './on-market-new-dev-parent.style';
import * as sharedStyles from './on-market.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OnMarketNewDevParentListingDetails on Property {\n    listing {\n      description\n      media {\n        firstVideo: items(first: 1, types: VIDEO) {\n          imageSrc\n          mediaSrc\n        }\n        items {\n          order\n          type\n          imageSrc\n          mediaSrc\n          title\n        }\n      }\n    }\n    agents {\n      agentId\n    }\n    development {\n      website\n      coverImage\n      logo {\n        image\n        foregroundColour\n        backgroundColour\n      }\n      developer {\n        description\n        name\n        logo\n        url\n      }\n      builder {\n        description\n        name\n        logo\n      }\n      type\n    }\n    agencies {\n      images {\n        tinyLogo\n      }\n      name\n      description\n    }\n  }\n"])));
var BaseOnMarketNewDevParentListingDetails = props => {
  var _property$agents, _property$development, _property$development2, _property$development3, _property$development4, _property$development5, _property$development6, _property$development7, _property$development8, _property$listing, _property$listing$med;
  useSendPageView();
  var sidebarBottomRef = useRef();
  var enquiryFormStart = useRef();
  var property = props.property;
  var _props$media = props.media,
    mobile = _props$media.mobile,
    tablet = _props$media.tablet,
    desktop = _props$media.desktop;
  var backToSearch = useBackToSearch(props.referrer);
  var handleEmailClick = (agency, agent) => {
    scrollToEnquiryForm({
      agency,
      agent
    });
  };
  var hasAgents = ((_property$agents = property.agents) === null || _property$agents === void 0 ? void 0 : _property$agents.length) > 0;
  return ___EmotionJSX("div", null, mobile && hasAgents && ___EmotionJSX(StickyMobile, {
    limitRef: enquiryFormStart
  }, ___EmotionJSX(MobileEnquiryCTAGraphQL, {
    property: property,
    onEmailClick: () => handleEmailClick(property.agencies[0]),
    applyOnlineLink: props.applyOnlineLink
  })), ((_property$development = property.development) === null || _property$development === void 0 ? void 0 : (_property$development2 = _property$development.logo) === null || _property$development2 === void 0 ? void 0 : _property$development2.image) && ___EmotionJSX(DevelopmentHeader, {
    backgroundColour: (_property$development3 = property.development) === null || _property$development3 === void 0 ? void 0 : (_property$development4 = _property$development3.logo) === null || _property$development4 === void 0 ? void 0 : _property$development4.backgroundColour,
    foregroundColour: (_property$development5 = property.development) === null || _property$development5 === void 0 ? void 0 : (_property$development6 = _property$development5.logo) === null || _property$development6 === void 0 ? void 0 : _property$development6.foregroundColour,
    logo: (_property$development7 = property.development) === null || _property$development7 === void 0 ? void 0 : (_property$development8 = _property$development7.logo) === null || _property$development8 === void 0 ? void 0 : _property$development8.image
  }), mobile && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX("div", {
    css: styles.heroImages
  }, ___EmotionJSX(ParentDevelopmentCoverPhotoGraphQL, {
    property: property
  }), props.carouselOpen && !isEmpty((_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$med = _property$listing.media) === null || _property$listing$med === void 0 ? void 0 : _property$listing$med.items) && ___EmotionJSX(EventBoundary, {
    name: "listing"
  }, ___EmotionJSX(AllhomesListingPhotoCarousel, {
    fullscreenOnOpen: mobile,
    items: props.items,
    initialIndex: props.initialIndex,
    onSlideChange: props.onSlideChange,
    onSlideClick: props.onSlideClick,
    onSlideLeft: props.onSlideLeft,
    onSlideRight: props.onSlideRight,
    onClose: props.onClose
  }))), mobile && ___EmotionJSX("div", null, ___EmotionJSX(NextEventGraphQL, {
    property: property
  })), ___EmotionJSX(Inner, null, tablet && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(InnerLeft, {
    css: styles.devLeft
  }, desktop && ___EmotionJSX(AllhomesBreadcrumbs, {
    css: sharedStyles.breadcrumbs,
    items: props.breadcrumbs,
    goBackText: backToSearch.text,
    goBackUrl: backToSearch.link
  }), ___EmotionJSX(AllhomesListingSummaryGraphQL, {
    property: property,
    onAddToWatchlist: props.onAddToWatchlist,
    onViewMoreClick: props.onDescriptionExpand,
    onResizeFinished: () => window.dispatchEvent(new Event('resize')),
    onLogoClicked: handleEmailClick,
    clientRenderedDescription: props.clientRenderedDescription
  }, ___EmotionJSX(NbnCardGraphQL, {
    property: property
  })), ___EmotionJSX(Section, {
    shortTopMargin: true
  }, ___EmotionJSX(NewDevelopmentParentDetailsGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(FeaturedArticle, {
    article: property.listing.featuredArticle
  })), ___EmotionJSX(Section, null, ___EmotionJSX(InspectionsAuctionsGraphQL, {
    property: property,
    onRemoveFromPlanner: props.onRemoveFromPlannerClick,
    onSignUpClick: props.onSignUpClick,
    onSignInClick: props.onSignInClick,
    onContactAgentClick: handleEmailClick,
    onVideoClick: props.onClickVideo,
    onVirtualTourClick: props.onClickVirtualTour
  })), (tablet || desktop) && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), ___EmotionJSX(Section, null, ___EmotionJSX(Description, {
    title: "About project ".concat(property.development.name),
    viewHeight: 174,
    description: property.listing.description
  })), ___EmotionJSX(ProjectEntityInfo, _extends({}, property, {
    onDeveloperLinkClick: props.onParentDevelopmentLinkClick
  })), ___EmotionJSX("div", {
    ref: sidebarBottomRef
  })), (tablet || desktop) && ___EmotionJSX(InnerRight, null, ___EmotionJSX(StickySidebox, {
    sidebarBottom: sidebarBottomRef
  }, ___EmotionJSX(OnMarketSidebox, _extends({}, props, {
    property: property,
    onEmailClick: handleEmailClick
  })))), ___EmotionJSX(Clear, null), !isEmpty(property.address.coordinates) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(Clear, null), ___EmotionJSX(AllhomesListingMapGraphQL, _extends({
    property: property,
    onTabSelect: props.onMapTypeSelect,
    onOverlaySelect: props.onMapOverlaySelect,
    onMapFirstInteraction: props.onMapFirstInteraction
  }, props))), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesKeyDetailsGraphQL, {
    property: property
  })), mobile && ___EmotionJSX(Section, null, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "mobile"
  })), !isEmpty(property.address.nearbyPOIs) && ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }, ___EmotionJSX(AllhomesListingWhatsNearbyGraphQL, {
    property: property,
    columns: desktop ? 3 : 2
  })), ___EmotionJSX(Bottom, null, (tablet || desktop) && ___EmotionJSX(Section, {
    fullWidth: true
  }, ___EmotionJSX(AllhomesListingSuburbStatsGraphQL, {
    property: property,
    onSuburbInfoClick: props.onSuburbInfoClick,
    onSummaryTabClick: props.onSummaryTabClick,
    onMedianSalesTabClick: props.onMedianSalesTabClick,
    onViewMoreInfoClick: props.onViewMoreInfoClick,
    onUVClick: props.onUVClick,
    disableAnimation: props.disableAnimation,
    layout: "tabbed"
  })), mobile && ___EmotionJSX(Section, {
    fullWidth: true,
    borderless: mobile
  }), ___EmotionJSX("div", {
    ref: enquiryFormStart
  }), ___EmotionJSX(ListingEnquiryFormGraphQL, _extends({
    property: property,
    sponsorship: props.sponsorship
  }, props.enquiryFormProps)))), ___EmotionJSX(ListingViewsGraphQL, {
    property: property
  }));
};
BaseOnMarketNewDevParentListingDetails.fragment = fragment;
BaseOnMarketNewDevParentListingDetails.propTypes = _objectSpread(_objectSpread({}, ListingDetailsCommonProps), {}, {
  onInspectFromHomeClick: PropTypes.func,
  onParentDevelopmentLinkClick: PropTypes.func
});
BaseOnMarketNewDevParentListingDetails.defaultProps = _objectSpread(_objectSpread({}, ListingDetailsDefaultValues), {}, {
  onInspectFromHomeClick: () => {},
  onParentDevelopmentLinkClick: () => {}
});
export default onMarketPropertyWrapper(withEventBoundary('development')(BaseOnMarketNewDevParentListingDetails));
export { BaseOnMarketNewDevParentListingDetails };